import { render, staticRenderFns } from "./Reduce_debt_details.vue?vue&type=template&id=183892b3&scoped=true&"
import script from "./Reduce_debt_details.vue?vue&type=script&lang=js&"
export * from "./Reduce_debt_details.vue?vue&type=script&lang=js&"
import style0 from "./Reduce_debt_details.vue?vue&type=style&index=0&id=183892b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183892b3",
  null
  
)

export default component.exports